"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.StitcherEvent = exports.AdMonitorEvent = exports.TrackingCuePoints = void 0;
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
exports.TrackingCuePoints = {
    25: js_player_shared_1.TrackingEvent.FIRST_QUARTILE,
    50: js_player_shared_1.TrackingEvent.MIDPOINT,
    75: js_player_shared_1.TrackingEvent.THIRD_QUARTILE,
};
exports.AdMonitorEvent = {
    AD_START: "AD_START",
    AD_END: "AD_END",
    ADBLOCK_START: "ADBLOCK_START",
    ADBLOCK_END: "ADBLOCK_END",
    ADBLOCK_ADDED: "ADBLOCK_ADDED",
};
exports.StitcherEvent = {
    ADBLOCK: "ADBLOCK",
};
//# sourceMappingURL=constants.js.map